<template>
  <div class="saved">
    <transition name="scroll">
      <p v-if="tracks.length === 0">
        You can create a playlist of your favorite songs by clicking the
        <span class="iconfavorite2"></span> button. Try it out.
      </p>
      <div id="playlist">
        <SpotifyButton
          v-if="tracks.length > 0"
          :tracks="tracks"
          :showPlayer="showPlayer"
          @toggleProperty="toggleProperty"
          :name="`MWYA Saved Tracks -- ${currentDate}`"
        />
        <div v-if="isLoading">
          <img src="loader.svg" height="400" width="300" />
        </div>
        <ul v-if="tracks.length > 0" class="cards">
          <MusicCard
            v-for="(a, index) in tracks"
            :track="a"
            :name="a.name"
            :artists="a.artists"
            :id="a.id"
            :key="a.idindex"
            :index="index"
            :shouldRemove="true"
            @getInfo="getInfo"
            @removeItem="remove"
          />
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import MusicCard from "@/components/MusicCard.vue";
import GeneralInfo from "@/components/GeneralInfo.vue";
import SpotifyButton from "@/components/SpotifyButton.vue";
import {
  sortArrAsc,
  sortObjDsc,
  flattenArrayOfObjects,
  removeDuplicatesArrObj,
  getAllIndices
} from "@/utils/arrays";

const isLocalHost = window.location.origin.indexOf("localhost") > -1;
const baseUrl = isLocalHost
  ? "https://localhost:3000/"
  : "https://api.musicwhereyouare.com/";
// const baseUrl ="https://api.musicwhereyouare.com/";
export default {
  name: "saved",
  components: {
    MusicCard,
    GeneralInfo,
    SpotifyButton
  },
  data() {
    return {
      tracks: [],
      isLoading: false,
      showPlayer: false,
      currentDate: undefined
    };
  },
  mounted: function() {
    this.fetchTracksFromStorage();
  },

  methods: {
    fetchTracksFromStorage() {
      const today = new Date();
      const hh =
        today.getHours().toString().length === 1
          ? `0${today.getHours()}`
          : today.getHours();
      const mnmn =
        today.getMinutes().toString().length === 1
          ? `0${today.getMinutes()}`
          : today.getMinutes();
      const dd =
        today.getDate().toString().length === 1
          ? `0${today.getDate()}`
          : today.getDate();
      const mm = today.getMonth() + 1;
      const yy = today.getFullYear();
      this.currentDate = `${mm}-${dd}-${yy}--${hh}:${mnmn}`;

      this.tracks = localStorage.favoriteArr
        ? JSON.parse(localStorage.favoriteArr)
        : [];
    },

    toggleProperty: function(isTrue, property) {
      this[property] = !isTrue;
    },

    remove: function(index) {
      this.tracks.splice(index, 1);
    },

    getInfo(artist) {
      this.showInfo = true;
      this.artist = artist;
      this.dataUrls.bio = `https://ws\.audioscrobbler\.com/2\.0/\?method=artist\.getinfo&api_key=9ad9e2c940182c94e99f042da78cabbe&format=json&artist=${
        artist.name
      }`;
      this.dataUrls.artist = `${baseUrl}artistsName/${artist.name}`;
      this.dataUrls.related = `${baseUrl}relatedName/${artist.name}`;
      this.dataUrls.topTracks = `${baseUrl}topTracksName/${artist.name}`;
    }
  }
};
</script>

<style>
.container {
  display: flex;
}
.related-artist-list-item {
  display: inline-flex;
}

.image-bio {
  display: flex;
}

.info-image-container {
  padding: 0 16px 0 0;
}

.info-related-item {
  display: block;
  width: 160px;
  margin: 0 16px 16px 0;
}

.top-tracks-list {
  margin-left: 24px;
}

.top-tracks-item {
  list-style: none;
}
</style>
